import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings')({
  component: () => (
    <Navigate
      from="/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings"
      to="/workspaces/$workspaceId/bots/$botId/webchat/v2/features"
    />
  ),
})
